import LanguageSwitcherModal from './LanguageSwitcherModal';

export default {
  LanguageSwitcherModal,
};
